import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import DateInputBase from '../base/DateInputBase';

interface IDateInputProps {
    name: string;
    label: string;
}

const DateInput: React.FC<IDateInputProps> = (props) => {
    try {
        const { control } = useFormContext();
        return (
            <Controller
                name={props.name}
                control={control}
                render={({ onChange, value }) => <DateInputBase onChange={onChange} value={value} {...props} />}
            />
        );
    } catch {
        return <div>reactHookForm/TextInput must be inside a react-hook-form FormProvider</div>;
    }
};

DateInput.displayName = 'DateInput';

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/controls/forms/reactHookForm/DateInput.tsx